module.exports = __webpack_public_path__ + "img/wb_iye.e5fb2d17.jpg";